/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmEvalsDeleteSuite } from "../../funcs/llmEvalsDeleteSuite.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.DeleteEvalSuiteRequest$inboundSchema,
};

export const tool$llmEvalsDeleteSuite: ToolDefinition<typeof args> = {
  name: "llm-evals-delete-suite",
  description: `Delete an eval suite

Soft-deletes an eval suite and all of its eval runs so they no longer appear in user-facing reads.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmEvalsDeleteSuite(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
